import React from 'react';
import Gravatar from 'react-gravatar'
import { useHistory } from 'react-router';
// import { Redirect } from 'react-router';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Helmet from "components/common/Helmet";
import TextLoop from "react-text-loop";
import Footer from 'components/footer/Footer';
import Header from 'components/header/Header';
// import HeaderThree from "../component/header/HeaderThree";
// import FooterTwo from "../component/footer/FooterTwo";
import Loader from 'components/Loader';
import ContactTwo from 'components/contact/ContactTwo';
import TabTwo from "components/tab/TabTwo";
// import ContactThree from "../elements/contact/ContactThree";
// import PortfolioList from "../elements/portfolio/PortfolioList";
// import ServiceList from "../elements/service/ServiceList";
// import BlogContent from "../elements/blog/BlogContent";

const SlideList = [
    {
        textPosition: 'text-left',
        category: 'Welcome to Infinity Comics',
        description: '',
        buttonText: 'Logout',
        buttonLink: '/'
    }
]

const Profile = (props) => {

    const { authUser, firebase } = props;

    const history = useHistory()

    const handleLogout = () => {
      firebase.signOut()
        .then(() => history.replace('/'))
        .catch((err) => console.log(err))
    }

    let title = 'About You',
        description = '';
    // const PostList = BlogContent.slice(0 , 3);
    return (
        <div id="profile" className="active-dark">
            <Helmet pageTitle="My Profile" />

            <Header headertransparent="header--transparent" color="color--white" logoname="logo.png" />

          { authUser ? <div>
            {/* Start Slider Area   */ }
            <div id="profile" className="fix">
              <div className="slider-wrapper">
                {/* Start Single Slide */ }
                { SlideList.map((value, index) => (
                  <div
                    className="slide personal-portfolio-slider slider-paralax slider-style-3 d-flex align-items-center justify-content-center bg_image"
                    key={ index }>
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className={ `inner ${ value.textPosition }` }>
                            <h1 className="title">Hi, { authUser.displayName } </h1> <br/>
                            { value.category ? <span>{ value.category }</span> : '' }
                            <h1 className="title">
                              <TextLoop>
                                <span> Transcending</span>
                                <span> Afritainment</span>
                                <span> Movies</span>
                                <span> Shows</span>
                                <span> Entertainment</span>
                                <span> Africa</span>
                              </TextLoop>{ ' ' }
                            </h1>
                            {/*<h2>based in .</h2>*/ }
                            { value.description ? <p className="description">{ value.description }</p> : '' }
                            { value.buttonText ? <div className="slide-btn"><button  className="rn-button-style--2 btn-solid" onClick={ handleLogout }>{ value.buttonText }</button>
                            </div> : '' }

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )) }
                {/* End Single Slide */ }
              </div>
            </div>
            {/* End Slider Area   */ }

            {/*/!* Start About Area *!/*/ }

            <div className="fix">
            <div className="about-area ptb--120  bg_color--1">
                <div className="about-wrapper">
                    <div className="container">
                        <div className="row row--35 align-items-center">
                            <div className="col-lg-5">
                                <div className="thumbnail">
                                    <Gravatar size={300} email={authUser.email} className="profile-image" alt="About Images"/>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="about-inner inner">
                                    <div className="section-title">
                                        <h2 className="title">{title}</h2>
                                        <p className="description">{description}</p>
                                    </div>
                                    <div className="row mt--30">
                                        <TabTwo authUser={authUser} tabStyle="tab-style--1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>

            {/* End About Area */ }

            {/*/!* Start Service Area  *!/*/ }
            {/*<div id="service" className="fix">*/ }
            {/*    <div className="service-area creative-service-wrapper ptb--120 bg_color--5" >*/ }
            {/*        <div className="container">*/ }
            {/*            <div className="row">*/ }
            {/*                <div className="col-lg-12">*/ }
            {/*                    <div className="section-title text-center service-style--3 mb--30 mb_sm--0">*/ }
            {/*                        <h2 className="title">My Awesome Service</h2>*/ }
            {/*                        <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>*/ }
            {/*                    </div>*/ }
            {/*                </div>*/ }
            {/*            </div>*/ }
            {/*            <div className="row creative-service">*/ }
            {/*                <div className="col-lg-12">*/ }
            {/*                    <ServiceList item="6" column="col-lg-4 col-md-6 col-sm-6 col-12 text-left" />*/ }
            {/*                </div>*/ }
            {/*            </div>*/ }
            {/*        </div>*/ }
            {/*    </div>*/ }
            {/*</div>*/ }
            {/*/!* End Service Area  *!/*/ }

            {/*/!* Start Portfolio Area *!/*/ }
            {/*<div id="portfolio" className="fix">*/ }
            {/*    <div className="portfolio-area ptb--120 bg_color--1">*/ }
            {/*        <div className="portfolio-sacousel-inner">*/ }
            {/*            <div className="container">*/ }
            {/*                <div className="row">*/ }
            {/*                    <div className="col-lg-12">*/ }
            {/*                        <div className="section-title text-center service-style--3 mb--30 mb_sm--0">*/ }
            {/*                            <h2 className="title">My Latest Project</h2>*/ }
            {/*                            <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>*/ }
            {/*                        </div>*/ }
            {/*                    </div>*/ }
            {/*                </div>*/ }
            {/*                <div className="row">*/ }
            {/*                    <PortfolioList styevariation="text-center mt--40" column="col-lg-4 col-md-6 col-sm-6 col-12" item="6" />*/ }
            {/*                </div>*/ }
            {/*                <div className="row">*/ }
            {/*                    <div className="col-lg-12">*/ }
            {/*                        <div className="view-more-btn mt--60 mt_sm--30 text-center">*/ }
            {/*                            <a className="rn-button-style--2 btn-solid" href="/blog"><span>View More</span></a>*/ }
            {/*                        </div>*/ }
            {/*                    </div>*/ }
            {/*                </div>*/ }
            {/*            </div>*/ }
            {/*        </div>*/ }
            {/*    </div>*/ }
            {/*</div>*/ }
            {/*/!* End Portfolio Area *!/*/ }

            {/* Start Contact Page Area  */ }
            <div className="rn-contact-page ptb--120 bg_color--1">
              <ContactTwo/>
            </div>
            {/* End Contact Page Area  */ }

            {/*/!* Start COntact Area *!/*/ }
            {/*<div id="contact" className="fix">*/ }
            {/*    <div className="rn-contact-area ptb--120 bg_color--1">*/ }
            {/*        <ContactThree contactImages="/assets/images/about/about-9.jpg" contactTitle="Hire Me." />*/ }
            {/*    </div>*/ }
            {/*</div>*/ }
            {/*/!* End COntact Area *!/*/ }
          </div> : <Loader /> }

            <Footer />
            {/* Start Back To Top */}
            <div className="backto-top">
                <ScrollToTop showUnder={160}>
                    <FiChevronUp />
                </ScrollToTop>
            </div>
            {/* End Back To Top */}

        </div>
    )
}

export default Profile;
